function animateValue(obj, start, end, duration) {
  let startTimestamp = null
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp
    const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    obj.innerHTML = Math.floor(progress * (end - start) + start) + '%'
    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }
  window.requestAnimationFrame(step)
}
const obj = document.querySelector('.review_filler_percentage')

$('.start_quiz').click(function (e) {
  e.preventDefault()
  $(this).addClass('animated_button')
  $(this).parents('.quiz_bundle_main_top').addClass('animated')
  var this_element = $(this)
  setTimeout(function () {
    $('.quiz_bundle_main_top').addClass('non_active')
    $('.quiz_bundle_main').addClass('active')
    this_element.removeClass('animated_button')
    this_element.parents('.quiz_bundle_main_top').removeClass('animated')
  }, 1000)
})

$('.quiz_input').on('input', function (e) {
  var text = $(this).val()
  if (text != '') {
    $(this).parents('.quiz_bundle_item').find('.answer_forward_button').removeClass('disabled')
  } else {
    $(this).parents('.quiz_bundle_item').find('.answer_forward_button').addClass('disabled')
  }
})
function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/
  return emailReg.test($email)
}
$('.quiz_input[name="email"]').on('input', function (e) {
  var text = $(this).val()
  if (!validateEmail(text)) {
    $(this).parents('.quiz_bundle_item').find('.answer_forward_button').addClass('disabled')
  } else {
    $(this).parents('.quiz_bundle_item').find('.answer_forward_button').removeClass('disabled')
  }
})

$('.quiz_radio').on('change', function (e) {
  $(this).parents('.quiz_bundle_item').find('.answer_forward_button').removeClass('disabled')
})

$('.quiz_checkbox').on('change', function (e) {
  var checked = $(this).parents('.quiz_bundle_item').find('input:checked')
  var checked_length = checked.length
  var checked_value = $(this).val()
  var check_limit = $(this).parents('.answer_options')
  if (check_limit.hasClass('max_3')) {
    if (checked_length == 3) {
      $(this).parents('.quiz_bundle_item').find('input:not(:checked)').prop('disabled', true)
      $(this).parents('.quiz_bundle_item').find('input.quiz_checkbox[value="None"]').removeAttr('disabled')
    } else {
      $(this).parents('.quiz_bundle_item').find('input:not(:checked)').removeAttr('disabled')
    }
  }
  if (checked_value == 'None') {
    $(this).parents('.quiz_bundle_item').find('input:checked').prop('checked', false)
    $(this).prop('checked', true)
  } else {
    $(this).parents('.quiz_bundle_item').find('input[value="None"]').prop('checked', false)
  }
  if (checked_length > 0) {
    $(this).parents('.quiz_bundle_item').find('.answer_forward_button').removeClass('disabled')
  } else {
    $(this).parents('.quiz_bundle_item').find('.answer_forward_button').addClass('disabled')
  }
})

$('.answer_forward_button').click(function (e) {
  e.preventDefault()
  if ($(this).hasClass('disabled')) {
  } else {
    var this_element = $(this)

    var check_last = $(this).parents('.quiz_bundle_item')
    if (check_last.hasClass('last_item')) {
      $(this).addClass('animated_button')
      var first_name = $('input#first_name').val()
      var email = $('input#email').val()
      var question1 = $('.quiz_bundle_item[data_tab="1"] .question_title').attr('data_value')
      var answer1 = $('.quiz_bundle_item[data_tab="1"] .quiz_input').val()
      var question2 = $('.quiz_bundle_item[data_tab="2"] .question_title').attr('data_value')
      var answer2 = $('.quiz_bundle_item[data_tab="2"] .quiz_radio:checked').val()
      //var question3 = $('.quiz_bundle_item[data_tab="3"] .question_title').attr('data_value');
      //var answer3= $('.quiz_bundle_item[data_tab="3"] .quiz_radio:checked').val();
      //var question4 = $('.quiz_bundle_item[data_tab="4"] .question_title').attr('data_value');
      //var answer4= $('.quiz_bundle_item[data_tab="4"] .quiz_radio:checked').val();
      //var question5 = $('.quiz_bundle_item[data_tab="5"] .question_title').attr('data_value');
      //var answer5= $('.quiz_bundle_item[data_tab="5"] .quiz_radio:checked').val();
      var question6 = $('.quiz_bundle_item[data_tab="6"] .question_title').attr('data_value')
      var answer6 = $('.quiz_bundle_item[data_tab="6"] .quiz_radio:checked').val()
      var question8 = $('.quiz_bundle_item[data_tab="8"] .question_title').attr('data_value')
      var answer8 = $('.quiz_bundle_item[data_tab="8"] .quiz_radio:checked').val()
      var question9 = $('.quiz_bundle_item[data_tab="9"] .question_title').attr('data_value')
      var answer9 = $('.quiz_bundle_item[data_tab="9"] .quiz_radio:checked').val()
      var question10 = $('.quiz_bundle_item[data_tab="10"] .question_title').attr('data_value')
      var answer10 = $('.quiz_bundle_item[data_tab="10"] .quiz_radio:checked').val()
      var question11 = $('.quiz_bundle_item[data_tab="11"] .question_title').attr('data_value')
      var answer11 = $('.quiz_bundle_item[data_tab="11"] .quiz_radio:checked').val()
      var question12 = $('.quiz_bundle_item[data_tab="12"] .question_title').attr('data_value')
      var answer12 = ' , '
      $('.quiz_bundle_item[data_tab="12"] .quiz_checkbox:checked').each(function () {
        answer12 = answer12 + ' , ' + jQuery(this).val()
      })
      answer12 = answer12.replace(' ,  , ', '')
      var question13 = $('.quiz_bundle_item[data_tab="13"] .question_title').attr('data_value')
      var answer13 = $('.quiz_bundle_item[data_tab="13"] .quiz_radio:checked').val()
      var question14 = $('.quiz_bundle_item[data_tab="14"] .question_title').attr('data_value')
      var answer14 = ' , '
      $('.quiz_bundle_item[data_tab="14"] .quiz_checkbox:checked').each(function () {
        answer14 = answer14 + ' , ' + jQuery(this).val()
      })
      answer14 = answer14.replace(' ,  , ', '')
      var question15 = $('.quiz_bundle_item[data_tab="15"] .question_title').attr('data_value')
      var answer15 = ' , '
      $('.quiz_bundle_item[data_tab="15"] .quiz_checkbox:checked').each(function () {
        answer15 = answer15 + ' , ' + jQuery(this).val()
      })
      answer15 = answer15.replace(' ,  , ', '')
      var question16 = $('.quiz_bundle_item[data_tab="16"] .question_title').attr('data_value')
      var answer16 = $('.quiz_bundle_item[data_tab="16"] .quiz_radio:checked').val()
      var question17 = $('.quiz_bundle_item[data_tab="17"] .question_title').attr('data_value')
      var answer17 = $('.quiz_bundle_item[data_tab="17"] .quiz_radio:checked').val()
      var question19 = $('.quiz_bundle_item[data_tab="19"] .question_title').attr('data_value')
      var answer19 = $('.quiz_bundle_item[data_tab="19"] .quiz_input').val()
      $.ajax({
        url: 'https://irestore.dreamhosters.com/klaviyo/klaviyo.php',
        type: 'post',
        data: {
          first_name: first_name,
          email,
          question1,
          answer1,
          question2,
          answer2,
          question6,
          answer6,
          question8,
          answer8,
          question9,
          answer9,
          question10,
          answer10,
          question11,
          answer11,
          question12,
          answer12,
          question13,
          answer13,
          question14,
          answer14,
          question15,
          answer15,
          question16,
          answer16,
          question17,
          answer17,
          question19,
          answer19,
        },
        success: function (data) {
          var link = data
          setTimeout(function () {
            location.href = link
          }, 7000)
        },
      })
    } else {
      $(this).addClass('animated_button')
      $(this).parents('.quiz_bundle_item').addClass('animated').addClass('animate_front')
      var this_element = $(this)
      var active_tab = this_element.parents('.quiz_bundle_item').attr('data_tab')
      setTimeout(function () {
        this_element.removeClass('animated_button')
        this_element
          .parents('.quiz_bundle_item')
          .removeClass('animated')
          .removeClass('animate_front')
          .removeClass('active')
          .addClass('non_active')
        this_element.parents('.quiz_bundle_item').next().addClass('active')
        if (active_tab == '1') {
          $('span.progress_bar_fill').css('width', '13%')
        } else if (active_tab == '2') {
          var gender = $('.quiz_bundle_item[data_tab="2"] .quiz_radio:checked').val()
          if (gender == 'Male') {
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(0).click()
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(1).hide()
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(0).show()
            $('.quiz_bundle_item[data_tab="6"] .answer_tabs,.quiz_bundle_item[data_tab="6"] .question_sub_title').hide()
          } else if (gender == 'Female') {
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(1).click()
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(0).hide()
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(1).show()
            $('.quiz_bundle_item[data_tab="6"] .answer_tabs,.quiz_bundle_item[data_tab="6"] .question_sub_title').hide()
          } else {
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(0).click()
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(1).show()
            $('.quiz_bundle_item[data_tab="6"] .answer_tab').eq(0).show()
            $('.quiz_bundle_item[data_tab="6"] .answer_tabs,.quiz_bundle_item[data_tab="6"] .question_sub_title').show()
          }
          $('span.progress_bar_fill').css('width', '16%')
        } else if (active_tab == '3') {
          $('span.progress_bar_fill').css('width', '19%')
        } else if (active_tab == '4') {
          $('span.progress_bar_fill').css('width', '22%')
        } else if (active_tab == '5') {
          $('span.progress_bar_fill').css('width', '25%')
          $('span.number_bar').eq(1).addClass('active')
        } else if (active_tab == '6') {
          $('span.progress_bar_fill').css('width', '31.25%')
          $('span.number_bar').eq(1).addClass('active')
        } else if (active_tab == '7') {
          $('span.progress_bar_fill').css('width', '37.50%')
          $('span.number_bar').eq(1).addClass('active')
        } else if (active_tab == '8') {
          $('span.progress_bar_fill').css('width', '43.75%')
          $('span.number_bar').eq(1).addClass('active')
        } else if (active_tab == '9') {
          $('span.progress_bar_fill').css('width', '50%')
          $('span.number_bar').eq(2).addClass('active')
        } else if (active_tab == '10') {
          $('span.progress_bar_fill').css('width', '56.25%')
          $('span.number_bar').eq(2).addClass('active')
        } else if (active_tab == '11') {
          $('span.progress_bar_fill').css('width', '62.50%')
          $('span.number_bar').eq(2).addClass('active')
        } else if (active_tab == '12') {
          $('span.progress_bar_fill').css('width', '68.75%')
          $('span.number_bar').eq(2).addClass('active')
        } else if (active_tab == '13') {
          $('span.progress_bar_fill').css('width', '75%')
          $('span.number_bar').eq(3).addClass('active')
        } else if (active_tab == '14') {
          $('span.progress_bar_fill').css('width', '81.25%')
          $('span.number_bar').eq(3).addClass('active')
        } else if (active_tab == '15') {
          $('span.progress_bar_fill').css('width', '87.50%')
          $('span.number_bar').eq(3).addClass('active')
        } else if (active_tab == '16') {
          $('span.progress_bar_fill').css('width', '93.75%')
          $('span.number_bar').eq(3).addClass('active')
        } else if (active_tab == '17') {
          $('span.progress_bar_fill').css('width', '100%')
          $('span.number_bar').eq(4).addClass('active')
          $('.review_spinner_full').animate({ width: '100%' }, 5000, 'linear')
          animateValue(obj, 0, 100, 5000)
          setTimeout(function () {
            this_element.parents('.quiz_bundle_item').next().find('.answer_forward_button').trigger('click')
          }, 5000)
        }
      }, 1000)
    }
  }
})

$('.answer_back_button').click(function (e) {
  if ($(this).hasClass('back_start')) {
    $(this).addClass('animated_button')
    $(this).parents('.quiz_bundle_item').addClass('animated').addClass('animate_back')
    var this_element = $(this)
    setTimeout(function () {
      $('.quiz_bundle_main_top').removeClass('non_active')
      $('.quiz_bundle_main').removeClass('active')
      this_element.removeClass('animated_button')
      this_element.parents('.quiz_bundle_item').removeClass('animated').removeClass('animate_back')
    }, 1000)
  } else {
    e.preventDefault()
    $(this).addClass('animated_button')
    $(this).parents('.quiz_bundle_item').addClass('animated').addClass('animate_back')
    var this_element = $(this)
    setTimeout(function () {
      this_element.removeClass('animated_button')
      this_element
        .parents('.quiz_bundle_item')
        .removeClass('animated')
        .removeClass('animate_back')
        .removeClass('active')
      this_element.parents('.quiz_bundle_item').prev().removeClass('non_active').addClass('active')
    }, 1000)
  }
})

$('.answer_tab').click(function () {
  var current_tab = $(this).attr('data_tab')
  $(this).parents('.quiz_bundle_item').find('.answer_tab').removeClass('active')
  $(this).addClass('active')
  $(this).parents('.quiz_bundle_item').find('.answer_options').hide()
  $(this)
    .parents('.quiz_bundle_item')
    .find('.answer_options[data_tab="' + current_tab + '"]')
    .show()
})

/*
var settings = {
  "url": "https://a.klaviyo.com/api/profiles/",
  "method": "POST",
  mode: 'no-cors',
  "timeout": 0,
  "headers": {
    "revision": "2023-12-15",
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": "Klaviyo-API-Key pk_940535441fa164488b5c6e4f1abe81b41e"
  },
  "data": JSON.stringify({
    "data": {
      "type": "profile",
      "attributes": {
        "email": "testpost@gmail.com",
        "phone_number": "+919882886565",
        "external_id": "123",
        "first_name": "test",
        "last_name": "hitesh",
        "organization": "test",
        "title": "",
        "image": "",
        "location": {
          "address1": "",
          "address2": "",
          "city": "",
          "country": "",
          "latitude": "",
          "longitude": "",
          "region": "",
          "zip": "",
          "timezone": "",
          "ip": ""
        },
        "properties": {
          "Nothing too hard.What gender do you identify with?": "Male",
          "How oily vs. dry is your hair?": "On the oily side"
        }
      }
    }
  }),
};

$.ajax(settings).done(function (response) {
  console.log(response);
  
  var id = response[0].id;
alert(id);
var settings2 = {
  "url": "https://a.klaviyo.com/api/lists/VJwS6V/relationships/profiles/",
  "method": "POST",
  mode: 'no-cors',
  "timeout": 0,
  "headers": {
    "revision": "2023-12-15",
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": "Klaviyo-API-Key pk_940535441fa164488b5c6e4f1abe81b41e"
  },
  "data": JSON.stringify({
    "data": [
      {
        "type": "profile",
        "id": "01J2G8GPWZFJV9BQ9CKGKRT2Q0"
      }
    ]
  }),
};

$.ajax(settings2).done(function (response) {
  console.log(response);
alert(done);
});
});
*/
